import { loadNg1Module, ngmodule } from "../../bootstrap/ngmodule";
import { noteComponent } from './note.component';
import { noteListComponent } from './note.list.component';
import {
    noteState, noteListState, noteItemState, noteItemBasicState
    // , noteArchiveState
} from "./notes.states";
// import { noteItemComponent } from "./note.item.component";
// import { noteItemBasicComponent } from "./note.item.basic.component";
// import { noteArchiveComponent } from "./note.archive.component";

const subscriptionAppModule: aboTheme.INgModule = {
    components: {
        noteComponent
        , noteListComponent
        // , noteItemComponent
        // , noteItemBasicComponent
        // , noteArchiveComponent
    },
    states: [noteState, noteListState, noteItemState, noteItemBasicState
        // , noteArchiveState
    ],
};

loadNg1Module(ngmodule, subscriptionAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/notes/index.ts